import React from "react";
import * as apiServices from "../services/apiServices";
import request from "../services/requestService";
import { CREATE_AGENDA_ACTION, MOM_ACTION } from "../constant";
import { toast } from "react-toastify";
import { downloadAgendaParticipantsAPI } from "../services/apiServices";
import { successToastStyle, errorToastStyle } from "../customToast";

export const createMom = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.MOM_CREATE_START
    });
    return requestMethod(apiServices.createMomParams(params))
      .then(momResponse => {
        const payload = momResponse.data;
        return payload;
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.MOM_CREATE_FAILURE
        });
      });
  };
};

export const getMomDetails = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.MOM_DETAILS_START
    });
    return requestMethod(apiServices.getMomDetailsParams(params))
      .then(momResponse => {
        const payload = momResponse.data;
        dispatch({
          type: MOM_ACTION.MOM_DETAILS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.MOM_DETAILS_FAILURE
        });
      });
  };
};

export const onEditMomDetails = (requestMethod = request, params) => {
  return requestMethod(apiServices.getMomDetailsParams(params))
    .then(response => {
      return response.data;
    })
    .catch(e => {
      console.log("mom details Failed", e.message);
    });
};

export const agendaHistory = (requestMethod = request, params) => {
  return requestMethod(apiServices.agendaHistoryParams(params))
    .then(response => {
      return response.data;
    })
    .catch(e => {
      console.log("history details Failed", e.message);
    });
};

export const upcomingMOM = (requestMethod = request, params) => {
  return requestMethod(apiServices.upcomingMOMParams(params))
    .then(response => {
      return response.data;
    })
    .catch(e => {
      console.log("upcoming mom Failed", e.message);
    });
};

export const deleteMOM = (requestMethod = request, params) => {
  return requestMethod(apiServices.deleteMOMParams(params))
    .then(response => {
      return response.data;
    })
    .catch(e => {
      console.log("upcoming mom Failed", e.message);
    });
};

export const clearMomDetails = () => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.MOM_DETAILS_CLEAR
    });
  };
};

export const getAllMoms = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.GET_MOMS_START
    });
    return requestMethod(apiServices.getAllMomsParams(params))
      .then(momResponse => {
        const payload = momResponse.data;
        dispatch({
          type: MOM_ACTION.GET_MOMS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.GET_MOMS_FAILURE
        });
      });
  };
};

export const getAllPRAGATI = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.GET_MOMS_START
    });
    return requestMethod(apiServices.getAllPRAGATILists(params))
      .then(momResponse => {
        const payload = momResponse.data;
        dispatch({
          type: MOM_ACTION.GET_MOMS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.GET_MOMS_FAILURE
        });
      });
  };
};

export const getAgendaSummary = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.GET_AGENDA_SUMMARY_START
    });
    return requestMethod(apiServices._getAgendaSummary(params))
      .then(momResponse => {
        const payload = momResponse.data;
        dispatch({
          type: MOM_ACTION.GET_AGENDA_SUMMARY_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.GET_AGENDA_SUMMARY_FAILURE
        });
      });
  };
};

export const updateMom = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.UPDATE_MOM_START
    });
    return requestMethod(apiServices.updateMomParams(params))
      .then(momResponse => {
        const payload = momResponse.data;
        return payload;
        /* dispatch({
          type: MOM_ACTION.UPDATE_MOM_SUCCESS,
          payload
        }); */
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.UPDATE_MOM_FAILURE
        });
      });
  };
};

export const addDecision = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.ADD_DECISION_START
    });
    return requestMethod(apiServices.addDecisionParams(params))
      .then(decisionResponse => {
        const payload = decisionResponse.data;
        dispatch({
          type: MOM_ACTION.ADD_DECISION_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.ADD_DECISION_FAILURE
        });
      });
  };
};

export const loadPageInfo = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_AGENDA_ACTION.LOAD_PAGE_INFO_START
    });
    return requestMethod(apiServices.getCreateAgengaPageInfo(params))
      .then(response => {
        const payload = response.data;
        dispatch({
          type: CREATE_AGENDA_ACTION.LOAD_PAGE_INFO_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: CREATE_AGENDA_ACTION.LOAD_PAGE_INFO_FAILURE
        });
      });
  };
};

export const downloadMinuteAction = (requestMethod = request, id) => {
  return requestMethod(apiServices.downloadMinuteAPI(id))
    .then(response => {
      return response;
    })
    .catch(e => {
      return e;
    });
};

export const downloadAgendaBriefAction = (requestMethod = request, id) => {
  return requestMethod(apiServices.downloadAgendaBriefAPI(id))
    .then(response => {
      return response;
    })
    .catch(e => {
      return e;
    });
};

export const downloadAgendaParticipantsAction = (
  requestMethod = request,
  id
) => {
  return requestMethod(apiServices.downloadAgendaParticipantsAPI(id))
    .then(response => {
      return response;
    })
    .catch(e => {
      return e;
    });
};

export const sendMinuteAction = (requestMethod = request, id) => {
  return requestMethod(apiServices.sendMinuteAPI(id))
    .then(response => {
      return response;
    })
    .catch(e => {
      return e;
    });
};

export const getAgendaIssueAction = (
  requestMethod = request,
  id,
  checkAgenda
) => {
  return requestMethod(apiServices.getAgendaIssueActionAPI(id, checkAgenda))
    .then(response => {
      return response;
    })
    .catch(e => {
      return e;
    });
};

export const getAgendaStakeHolderAction = (requestMethod = request, id) => {
  return requestMethod(apiServices.getAgendaStokeHolderInfo(id)).then(resp => {
    return resp;
  });
};

export const getMeetingCardInfoAction = (requestMethod = request, data) => {
  return requestMethod(apiServices.getMeetingCardInfoApi(data)).then(resp => {
    return resp;
  });
};

export const setUpdateMeetingFilesAction = (requestMethod = request, data) => {
  return requestMethod(apiServices.setUpdatingMeetingFiles(data))
    .then(response => {
      return response;
    })
    .catch(e => {
      return e;
    });
};

export const sendMeetingRequest = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: MOM_ACTION.SEND_MEETING_REMINDER_START
    });
    return requestMethod(apiServices.setScheduledMeetingReminder(params))
      .then(momResponse => {
        const payload = momResponse.data;
        dispatch({
          type: MOM_ACTION.SEND_MEETING_REMINDER_SUCCESS,
          payload
        });
        toast.success(
          <p className="toast-text-alignment">Mail sent successfully!</p>,
          successToastStyle
        );
        return payload;
      })
      .catch(() => {
        dispatch({
          type: MOM_ACTION.SEND_MEETING_REMINDER_FAILURE
        });
        toast.error(
          <p className="toast-text-alignment">There is some error!</p>,
          errorToastStyle
        );
      });
  };
};
